import { useEffect } from 'react'
import { MultiSelect } from '@lmc/ui-kit'
import styled from 'styled-components'
import { LogCategoryItem, LogCategory } from '@lmc/ts-common'
import { useDispatch, useSelector } from 'react-redux'
import Operations from 'operations'
import { FilterValues } from '../MonitoringReport/MonitoringReport'
import { SelectVariant } from '@lmc/ui-kit/src/dataEntry/MultiSelect/MultiSelect'
import useIncidentTypeOptions from 'hooks/useIncidentTypeOptions'

type CategoryFiltersProps = {
  value: FilterValues
  reportingId?: string
  itemsPlaceholder?: string
  itemsCategoryFilter?: string
  variant: SelectVariant
  onChange: (value: Partial<FilterValues>) => void
}

const unwantedCategories = ['bodyMaps']

export const CategoryFilters = ({
  value,
  reportingId,
  itemsPlaceholder,
  itemsCategoryFilter,
  variant,
  onChange,
}: CategoryFiltersProps) => {
  const {
    'log-categories': categories,
    'log-category-items': categoryItems,
  }: {
    'log-categories': LogCategory[] | undefined
    'log-category-items': LogCategoryItem[] | undefined
  } = useSelector(
    (state: {
      data: {
        'log-category-items': LogCategoryItem[]
        'log-categories': LogCategory[]
      }
    }) => state.data
  )

  const dispatch = useDispatch()

  const categoryOptions = categories
    ?.filter((category) => !unwantedCategories.includes(category.itemId))
    .map((category) => ({
      label: category.name,
      value: category.id,
      image: (
        <CategoryImageContainer color={category.color}>
          <CategoryImage
            alt="category"
            src={category.icon as unknown as string}
          />
        </CategoryImageContainer>
      ),
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  useEffect(() => {
    if (!categoryItems?.length) {
      dispatch(Operations.loadList('log-category-items'))
    }
  }, [categoryItems])

  let newCategoryItems = categoryItems?.filter((categoryItem) =>
    value?.categories?.includes(categoryItem.category)
  )

  if (!newCategoryItems?.length) {
    newCategoryItems = categoryItems
  }

  const incidentTypes = useIncidentTypeOptions(itemsCategoryFilter)

  return (
    <>
      {reportingId === 'all' && (
        <StyledMultiSelect
          values={value.categories}
          title="Categories"
          options={categoryOptions || []}
          hasClear
          hasSearch
          hasSelectAll
          onChange={(selectedCategories) => {
            onChange({ categories: selectedCategories })
          }}
          variant={variant}
        />
      )}
      {['all', 'items']?.includes(reportingId as string) && (
        <StyledMultiSelectWide
          values={value.categoryItems}
          title={itemsPlaceholder || 'Items'}
          options={incidentTypes}
          hasClear
          hasSearch
          hasSelectAll
          onChange={(selectedCategoryItems) =>
            onChange({ categoryItems: selectedCategoryItems })
          }
          variant={variant}
        />
      )}
    </>
  )
}

const StyledMultiSelect = styled(MultiSelect)`
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    width: 100%;
  }
` as typeof MultiSelect

const StyledMultiSelectWide = styled(StyledMultiSelect)`
  min-width: 180px;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    width: 100%;
  }
` as typeof MultiSelect

const CategoryImageContainer = styled.div<{ color?: string | undefined }>`
  background-color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  overflow: 'hidden';
  width: 20px;
  height: 20px;
`
const CategoryImage = styled.img`
  width: 12px;
  height: 12px;
`
